"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What areas do you serve?",
  answer: "We proudly serve residential and commercial properties throughout Springfield, USA and the surrounding communities."
}, {
  question: "Do you offer free estimates?",
  answer: "Yes, we provide free, no-obligation quotes for all our services. Simply reach out to us to schedule an assessment of your property."
}, {
  question: "Are your maintenance services available year-round?",
  answer: "Absolutely. We offer comprehensive seasonal maintenance, ensuring your property remains in top condition regardless of the weather or time of year."
}, {
  question: "Do I need to provide cleaning supplies or equipment?",
  answer: "No, our professional team arrives fully equipped with high-quality materials, eco-friendly cleaning supplies, and commercial-grade equipment to handle any job efficiently."
}, {
  question: "Can I bundle multiple services together?",
  answer: "Yes! As your 'one-stop shop' for facility maintenance, we highly encourage bundling services such as landscaping, painting, and power washing for a seamless and cost-effective property care experience."
}];
export default function MaintenanceFaq() {
  return;
}